import React, { Component } from 'react';
import moment from 'moment';
import Alert from 'react-s-alert';

import SimplePopover from '../SimplePopover';

import Navegacao from './questoes/Navegacao';
import CartaoResposta from './questoes/CartaoResposta';
import Questao from './questoes/Questao';

import EdbButton from '../EdbButton';
import Loading from '../Loading';

import * as SimuladoRequest from '../../requests/simulado.request';
import * as GamificacaoRequest from '../../requests/gamificacao.request';
import { STATUS_QUESTAO, IDIOMA_ID } from '../../const';
import ModalConfirm from '../ModalConfirm';
import Instrucoes from './questoes/Instrucoes';

import { Subscribe } from 'unstated'
import UserContainer from '../../containers/user.container';

class QuestoesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            idExam: 0,
            loadingGeral: true,
            loadingIniciarSimulado: false,
            loadingQuestao: false,
            iniciado: false,
            questaoAtual: 0,
            tempoTotalMinutos: 30,
            numPeriodo: "1",
            nomeSimulado: "Simulado de Desenvolvimento",
            tempoAtual: "00:00:00",
            semConsulta: false,
            idTimeInterval: undefined,
            dtInicioSimulado: undefined,
            menuCartaoResposta: false,
            totalQuestoes: 0,
            questoes: [],
            showModalFinalizar: false,
            loadingFinalizar: false,
            escolherIdioma: true,
            idiomaSelecionado: undefined
        }

        this.onClickProximaEmBranco = this.onClickProximaEmBranco.bind(this);
        this.onClickProximaDuvida = this.onClickProximaDuvida.bind(this);
        this.onClickProximaQuestao = this.onClickProximaQuestao.bind(this);
        this.onClickQuestaoAnterior = this.onClickQuestaoAnterior.bind(this);
        this.onClickConfirmar = this.onClickConfirmar.bind(this);
        this.onClickDuvida = this.onClickDuvida.bind(this);
        this.onChangeOpcao = this.onChangeOpcao.bind(this);
        this.onClickQuestao = this.onClickQuestao.bind(this);
        this.onClickIniciarSimulado = this.onClickIniciarSimulado.bind(this);
        this.onTickTempo = this.onTickTempo.bind(this);
        this.abrirMenuCartaoResposta = this.abrirMenuCartaoResposta.bind(this);
        this.fecharMenuCartaoResposta = this.fecharMenuCartaoResposta.bind(this);
        this.onClickFecharModalFinalizar = this.onClickFecharModalFinalizar.bind(this);
        this.onClickConfirmarFinalizar = this.onClickConfirmarFinalizar.bind(this);
        this.onClickFinalizar = this.onClickFinalizar.bind(this);
        this.onClickSelecionarIdioma = this.onClickSelecionarIdioma.bind(this);
    }

    async componentDidMount() {

        // this.setState({ loadingGeral: false });
        // return;

        //------------------------------------------------------------------
        // //Verifica se tem dados do localStorage para restaurar
        // var storageState = this.getStateFromLocalStorage();
        // if (storageState) {

        //     //Atribui como estado atual
        //     this.setState(storageState);

        //     //Encerra o fluxo do DidMount
        //     return;
        // }
        //------------------------------------------------------------------

        try {
            //Parametro da URL
            var idExam = this.props.match.params.idExam;
            this.setState({ idExam: idExam });

            //Exibindo o loading
            this.setState({ loadingGeral: true });

            //Obtendo as instruções
            var instrucao = await SimuladoRequest.getInstrucoes(idExam);

            if (!instrucao) {
                Alert.error("Não foi possivel carregar este simulado. Tente novamente mais tarde.", { position: 'bottom-right' });
                window.location.hash = "#/";
                return;
            }
            // prazo encerrado
            if (instrucao.hasExpired === 1) {
                Alert.error("O prazo para iniciar este simulado foi expirado.", { position: 'bottom-right' });
                window.location.hash = "#/";
                return;
            }

            // liberação ainda a iniciar
            if (instrucao.canStart === 0) {
                Alert.error("Este simulado ainda não foi liberado para iniciar. Tente novamente mais tarde.", { position: 'bottom-right' });
                window.location.hash = "#/";
                return;
            }
            // liberação ainda a iniciar
            // *** permite todos continuar depois
            if (instrucao.hasStarted === 1 && false && !instrucao.inContinueExam) {
                Alert.error("Este simulado não permite continuar depois de iniciado.", { position: 'bottom-right' });
                window.location.hash = "#/";
                return;
            }
            this.setState({
                semConsulta: instrucao.inExamBlockWindow,
                nomeSimulado: instrucao.txExamName,
                tempoTotalMinutos: instrucao.nuTimeLimit,
                totalQuestoes: instrucao.nuQuestions,
                idiomaSelecionado: (instrucao.idDisciplineForeignLanguage===9 ? IDIOMA_ID.INGLES : IDIOMA_ID.ESPANHOL)
                //loadingGeral: false
            });

            // Se continua recupera a primeira questão
            if (instrucao.hasStarted === 1 /*&& instrucao.inContinueExam */) {
                this.setState({ iniciado: true }, function () {
                    this.popularQuestao(0);
                    window.scrollTo(0, 0);
                });
            }

            //Atribuindo na tela e escondendo o loading
            var periodo = "";
            if (instrucao.txPeriodPracticeTest) {
                periodo = instrucao.txPeriodPracticeTest.split('.')[1];
            }
            this.setState({
                numPeriodo: periodo
            });
console.log(this.state);
            //Verificando se este simulado já estava em andamento
            var marcacoes = await SimuladoRequest.getMarcacoes(idExam);
            // console.log(marcacoes);
            if (marcacoes) {

                this.atribuirMarcacoesQuestoes(marcacoes);

                //Inicia automaticamente o simulado
                await this.onClickIniciarSimulado();
            }

            this.setState({ loadingGeral: false });

            //this.saveStateToLocalStorage();
        }
        catch (e) {
            console.error(e);
            Alert.error("Não foi possivel carregar este simulado. Tente novamente mais tarde.", { position: 'bottom-right' });
            window.location.hash = "#/";
        }
    }

    // saveStateToLocalStorage() {
    //     var jsonString = JSON.stringify(this.state);
    //     localStorage.setItem("simulado", jsonString);
    // }

    // getStateFromLocalStorage() {
    //     var state = undefined;
    //     var jsonString = localStorage.getItem("simulado");
    //     if (jsonString) {
    //         state = JSON.parse(jsonString);
    //     }
    //     return state;
    // }

    atribuirMarcacoesQuestoes(marcacoes) {

        var questoes = this.state.questoes;

        for (let index = 0; index < marcacoes.length; index++) {
            const marcacao = marcacoes[index];

            var resposta = undefined;
            if (marcacao.a && marcacao.a[0]) {
                resposta = marcacao.a[0].idAnswer;
            }
            questoes[marcacao.nuDisplayOrder - 1] = {
                incompleta: true,
                id: marcacao.idQuestion,
                enunciado: "",
                opcoes: [],
                resposta: resposta,
                status: marcacao.inStatus
            };
        }

        this.setState({ questoes: questoes });
    }

    mapRespostasToApi(questao) {
        //Somente as que não estão em branco
        //var questoes = this.state.questoes.filter(f => f.status !== STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO);

        //Mapeando para o formato que a APi está esperando
        //var respostasApi = questoes.map(questao => ());

        var respostasApi = {
            answers: questao.resposta ? [questao.resposta] : [],
            inStatus: questao.status,
            nuTimeSpan: 0,
            idQuestion: questao.id
        }

        return respostasApi;
    }

    mapQuestaoApiToQuestao(questaoAPI) {

        var fonte = `(${questaoAPI.qs[0].coQuestionSource} ${questaoAPI.txYearReference}) `;

        var opcoes = questaoAPI.qs[0].qt[0].a.map(item => ({
            id: item.idAnswer,
            descricao: this.ajustarHtmlOpcao(item.txAnswer)
        }));

        var questao = {
            id: questaoAPI.idQuestion,
            enunciado: fonte + questaoAPI.txQuestion,
            opcoes: opcoes,
            resposta: undefined,
            status: STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO
        };

        return questao;
    }

    ajustarHtmlOpcao(htmlOpcao) {
        //Algumas opções de questões vem com o HTMl envolvidos com a tag <p>, e isso acaba quebrando o layout atual.
        //O codigo abaixo remove essa tag <p> que envolve a opção da questão
        var result = htmlOpcao;
        if (htmlOpcao && htmlOpcao.indexOf("<p") !== -1) {
            var idx = htmlOpcao.indexOf(">");
            var idxEndTag = htmlOpcao.indexOf("</p", idx);

            result = htmlOpcao.substring(idx + 1, idxEndTag);
        }
        return result;
    }

    abrirMenuCartaoResposta() {
        this.setState({ menuCartaoResposta: true });
    }

    fecharMenuCartaoResposta() {
        this.setState({ menuCartaoResposta: false });
    }

    async onClickIniciarSimulado() {

        try {

            //Se precisar, verifica se escolheu o idioma
            if (this.state.escolherIdioma && !this.state.idiomaSelecionado) {

                Alert.error("Você precisa escolher seu idioma de preferência.", { position: 'bottom-right' });
                return;
            }

            //Exibindo loading no botão iniciar
            this.setState({ loadingIniciarSimulado: true });
            // console.log('iniciar',this.state.idExam, this.state.idiomaSelecionado)
            //Iniciando simulado no servidor
            await SimuladoRequest.setIniciar(this.state.idExam, this.state.idiomaSelecionado);

            //Obtendo a primeira questão
            var result = await this.popularQuestao(0);

            if (!result) { throw new Error("Erro ao popular questão inicial."); }

            //Escondendo o loading e exibindo a primeira questão
            this.setState({
                loadingIniciarSimulado: false,
                iniciado: true,
                dtInicioSimulado: new Date(),
                loadingQuestao: false
            });
            window.scrollTo(0, 0);
            //this.saveStateToLocalStorage();

            //Iniciando o timer do tempo restante
            this.onTickTempo();

        }
        catch (e) {
            console.error(e);
            Alert.error("Não foi possível iniciar o simulado. Tente novamente mais tarde.", { position: 'bottom-right' });

            //Exibindo loading no botão iniciar
            this.setState({ loadingIniciarSimulado: false });
        }
    }
    onTickTempo() {

        //Se é um simulado sem tempo, não faz nada
        if (!this.state.tempoTotalMinutos) { return; }

        var dtNow = moment(new Date());
        var dtFimSimulado = moment(this.state.dtInicioSimulado).add(this.state.tempoTotalMinutos, 'minutes');


        var diff = dtFimSimulado.diff(dtNow);
        var duration = moment.duration(diff, 'milliseconds');
        var h = duration.hours().toString();
        var m = duration.minutes().toString();
        var s = duration.seconds().toString();

        if (diff >= 0) {
            if (h.length === 1) { h = "0" + h; }
            if (m.length === 1) { m = "0" + m; }
            if (s.length === 1) { s = "0" + s; }

            var time = `${h}:${m}:${s}`;

            this.setState({ tempoAtual: time });
        }
        else {
            //Parando o timer
            clearInterval(this.state.idTimeInterval);
            this.setState({ tempoAtual: "00:00:00" });
        }

    }
    onChangeOpcao(resp) {
        var numeroQuestao = this.state.questaoAtual + 1;
        var questao = this.getQuestaoAtual();
        questao.resposta = resp;

        this.atualizarQuestao(questao, this.state.questaoAtual);

        //Salvando a resposta na API caso a questão nao tenha sido confirmada, para evitar perda dessa marcação ao recarregar a tela
        if (questao.status !== STATUS_QUESTAO.QUESTAO_STATUS_RESPONDIDA) {
            this.salvarResposta(questao, numeroQuestao);
        }
    }

    async salvarResposta(questao, numeroQuestao) {

        var respostaApi = this.mapRespostasToApi(questao);
        var response = await SimuladoRequest.setResposta(this.state.idExam, respostaApi);
        //console.log("setResposta", response);
        if (!response) {
            Alert.error(`Não foi possível salvar sua resposta da questão nº ${numeroQuestao}. Tente novamente`, { position: 'bottom-right' });

            questao.status = STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO;
            this.atualizarQuestao(questao, numeroQuestao - 1);
        }
    }

    onClickConfirmar(resp) {
        var numeroQuestao = this.state.questaoAtual + 1;
        var questao = this.getQuestaoAtual();
        questao.resposta = resp;
        questao.status = STATUS_QUESTAO.QUESTAO_STATUS_RESPONDIDA;

        this.atualizarQuestao(questao, this.state.questaoAtual);
        this.onClickProximaQuestao();

        //Salvando respostas na API
        this.salvarResposta(questao, numeroQuestao);
    }

    onClickDuvida(resp) {
        var numeroQuestao = this.state.questaoAtual + 1;
        var questao = this.getQuestaoAtual();
        questao.status = STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA;

        this.atualizarQuestao(questao, this.state.questaoAtual);

        this.onClickProximaQuestao();

        //Salvando respostas na API
        this.salvarResposta(questao, numeroQuestao);
    }

    onClickQuestao(numeroQuestao) {
        var idx = (numeroQuestao - 1) || 0;
        //this.setState({ questaoAtual: idx, menuCartaoResposta: false });
        this.setState({ menuCartaoResposta: false });
        this.popularQuestao(idx);
        window.scrollTo(0, 0);
    }
    onClickProximaEmBranco() {
        this.irProximaQuestaoComStatus(STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO);
        window.scrollTo(0, 0);
    }
    onClickProximaDuvida() {
        this.irProximaQuestaoComStatus(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA);
        window.scrollTo(0, 0);
    }
    irProximaQuestaoComStatus(status) {

        //Tenta encontrar a proxima questão com o Status especificado a partir da questão atual
        var idx = this.getStatusQuestoes().indexOf(status, this.state.questaoAtual + 1);
        if (idx !== -1) {
            //this.setState({ questaoAtual: idx });
            this.popularQuestao(idx);
            return true;
        }
        else {
            //Se não encontrou nenhuma a partir da questão atual, tenta encontrar des do início das questões
            idx = this.getStatusQuestoes().indexOf(status, 0);
            if (idx !== -1) {
                //this.setState({ questaoAtual: idx });
                this.popularQuestao(idx);
                return true;
            }
        }
        return false;
    }

    onClickProximaQuestao() {
        if (this.state.questaoAtual + 1 < this.getTotalQuestoes()) {
            //this.setState({ questaoAtual: this.state.questaoAtual + 1 })
            this.popularQuestao(this.state.questaoAtual + 1);
            window.scrollTo(0, 0);
            return true;
        }
        return false;
    }
    onClickQuestaoAnterior() {
        if (this.state.questaoAtual - 1 >= 0) {
            //this.setState({ questaoAtual: this.state.questaoAtual - 1 })
            this.popularQuestao(this.state.questaoAtual - 1);
            window.scrollTo(0, 0);
        }
    }

    async popularQuestao(indexQuestao, naoCarregarProximaQuestao) {
        var result = false;

        //Vai para a questão  exibindo um loading
        if (!naoCarregarProximaQuestao) {
            this.setState({ questaoAtual: indexQuestao, loadingQuestao: true });
        }

        if (indexQuestao >= this.getTotalQuestoes())
            return;

        //Verifica se já tem carregado a questão informada
        var questao = this.state.questoes[indexQuestao];

        //Se não tem a questão carregada
        if (!questao || questao.incompleta) {

            //Armazena a resposta e o status anterior se houver
            var respostaAnterior = questao && questao.resposta;
            var statusAnterior = questao && questao.status;

            //Busca no servidor
            var questaoApi = await SimuladoRequest.getQuestao(this.state.idExam, indexQuestao + 1);
            if (questaoApi) {

                //Armazena no array de questões carregadas
                questao = this.mapQuestaoApiToQuestao(questaoApi);
                var questoes = this.state.questoes;

                //Aplica a resposta e o status anterior
                if (respostaAnterior) {
                    questao.resposta = respostaAnterior;
                }
                if (statusAnterior) {
                    questao.status = statusAnterior;
                }

                questoes[indexQuestao] = questao;
                this.setState({ questoes: questoes });

                result = true;
            }
        }

        //Popula a questão na tela sem o loading
        if (!naoCarregarProximaQuestao) {
            this.setState({ questaoAtual: indexQuestao, loadingQuestao: false });

            //Pre carrega a proxima questão
            this.popularQuestao(indexQuestao + 1, true);
        }

        return result;
    }



    atualizarQuestao(questao, idx) {
        var questoes = this.state.questoes;
        questoes[idx] = questao;

        this.setState({ questoes: questoes });
    }
    getQuestaoAtual() {
        if (this.state.questoes) {
            return this.state.questoes[this.state.questaoAtual] || {};
        }
        else {
            return {};
        }
    }
    getTotalQuestoes() {
        //return (this.state.questoes || []).length || this.state.totalQuestoes;
        return this.state.totalQuestoes;
    }
    getStatusQuestoes() {
        //var arrStatus = (this.state.questoes || []).map(questao => questao.status);
        var arrStatus = [];
        var qtd = this.getTotalQuestoes();
        for (let index = 0; index < qtd; index++) {

            var status = STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO;

            const questao = this.state.questoes[index];
            if (questao) {
                status = questao.status;
            }

            arrStatus.push(status);
        }
        return arrStatus;
    }

    getQuestoesStatus(status) {
        var questoes = (this.state.questoes || []).filter(f => f.status === status);
        return questoes;
    }

    getQtdQuestoesEmBranco() {
        //Não é possivel filtrar as questões por tipo em branco, pois algumas questões podem ainda nem terem sido buscadas no servidor,
        //por isso a lógica deve ser baseada no valor total
        var qtdQuestoesRespondidas = this.getQuestoesStatus(STATUS_QUESTAO.QUESTAO_STATUS_RESPONDIDA).length;
        var qtdQuestoesDuvida = this.getQuestoesStatus(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA).length;
        var qtdQuestoesBranco = this.state.totalQuestoes - qtdQuestoesDuvida - qtdQuestoesRespondidas;
        return qtdQuestoesBranco;
    }

    verificaTemQuestaoEmBranco() {
        var resultado = this.getStatusQuestoes().indexOf(STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO) !== -1;
        return resultado;
    }
    verificaTemQuestaoDuvida() {
        var resultado = this.getStatusQuestoes().indexOf(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA) !== -1;
        return resultado;
    }

    onClickFecharModalFinalizar() {
        this.setState({ showModalFinalizar: false });
    }

    onClickFinalizar() {
        this.setState({ showModalFinalizar: true });
    }

    async onClickConfirmarFinalizar() {
        this.setState({ loadingFinalizar: true });

        var result = await SimuladoRequest.setFinalizarSimulado(this.state.idExam);
        // console.log('onClickConfirmarFinalizar ', result)
        if (result) {
            var resultNota = await SimuladoRequest.setNotasTri(this.state.idExam);
        // console.log('resultNota ', resultNota)

            GamificacaoRequest.calcularPontuacaoUsuario()
            if(resultNota) {
                Alert.success("Simulado finalizado com sucesso.", { position: 'bottom-right' });
                this.props.history.push('/');
            }
            else {
                Alert.error("Não foi possível atualizar a sua nota TRI de seu simulado.", { position: 'bottom-right' });
                this.setState({ loadingFinalizar: false });
            }
        }
        else {
            Alert.error("Não foi possível finalizar seu simulado. Tente novamente mais tarde.", { position: 'bottom-right' });
            this.setState({ loadingFinalizar: false });
        }
    }

    onClickSelecionarIdioma(idIdioma) {
        this.setState({ idiomaSelecionado: idIdioma });
    }

    render() {
        return (<div className="">


            <ModalConfirm isOpen={this.state.showModalFinalizar}
                title="Tem certeza que deseja finalizar o simulado?"
                content={<div>

                    {/****** Quantidade de questões em branco ******/}
                    {this.getQtdQuestoesEmBranco() === 1 && <p>
                        Você ainda tem <span className="adap-text-red edb-text-bold">uma questão em branco</span>.
                    </p>}
                    {this.getQtdQuestoesEmBranco() > 1 && <p>
                        Você ainda tem <span className="adap-text-red edb-text-bold">{this.getQtdQuestoesEmBranco()} questões em branco</span>.
                    </p>}

                    {/****** Quantidade de questões em dúvida ******/}
                    {this.getQuestoesStatus(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA).length === 1 && <p>
                        Você ainda tem <span className="adap-text-red edb-text-bold">uma questão marcada como dúvida</span>.
                    </p>}
                    {this.getQuestoesStatus(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA).length > 1 && <p>
                        Você ainda tem <span className="adap-text-red edb-text-bold">{this.getQuestoesStatus(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA).length} questões marcadas como dúvida</span>.
                    </p>}
                </div>}

                confirmText="Sim, quero finalizar o simulado."
                confirmLoadingText="Finalizando, por favor aguarde..."
                onClickConfirm={this.onClickConfirmarFinalizar}
                loadingConfirm={this.state.loadingFinalizar}

                cancelText="Não, ainda preciso de mais tempo"
                onClickCancel={this.onClickFecharModalFinalizar}
            />


            {this.state.loadingGeral && <Loading />}

            {!this.state.loadingGeral && <div>
                {/* *********** Cabeçalho (Dektop) ************* */}
                <div className="edb-row edb-hide-small edb-margin-large-bottom">
                    <div className="edb-col m12 l6 edb-padding-small-mobile edb-padding-small-medium">
                        <span className="edb-xlarge edb-text-bold edb-margin-small-right">{this.state.numPeriodo}º PERÍODO</span>
                        <div className="edb-xlarge edb-inline edb-line-height-medium">| {this.state.nomeSimulado}</div>
                    </div>
                    <div className="edb-col m6 l2">
                        <div className="edb-row-cell ">
                            {this.state.iniciado && <div className="edb-cell edb-cell-middle edb-padding-small">
                                <i className="adap-xxlarge far fa-clock"></i>
                            </div>}
                            {this.state.iniciado && <div className="edb-cell ">
                                <div className="edb-line-height-medium">Tempo restante:</div>
                                <div className="edb-small edb-text-bold">{this.state.tempoAtual > 0 ? this.state.tempoAtual : "Ilimitado"}</div>
                            </div>}
                        </div>
                    </div>
                    {this.state.iniciado && <div className="edb-col m6 l4 edb-right-align edb-padding-right-mobile">
                        <button className="edb-button edb-round adap-green" onClick={this.onClickFinalizar}>Finalizar simulado</button>
                        {/* <SimplePopover noPadding={true} rightAlign={true} content={<div className="edb-bar-block" style={{ right: 0 }}>
                            <button className="edb-bar-item edb-button edb-medium ">Reportar erro</button>
                            </div>}>
                            <i className="fas fa-ellipsis-h edb-margin-left"></i>
                        </SimplePopover> */}
                    </div>}
                </div>

                {/* *********** Cabeçalho (Mobile) ************* */}
                <div className="edb-hide-large edb-hide-medium">
                    <div className="edb-row  edb-hide-medium adap-red2 edb-padding-small-top edb-padding-small-bottom">
                        <div className="edb-col s6 edb-padding-small-left">

                            <div className="edb-row-cell edb-margin-small-top">
                                {this.state.iniciado && <div className="edb-cell edb-cell-middle edb-padding-small">
                                    <i className="edb-xlarge far fa-clock"></i>
                                </div>}
                                {this.state.iniciado && <div className="edb-cell ">
                                    <div className="edb-tiny">Tempo restante:</div>
                                    <div className="edb-small edb-text-bold">{this.state.tempoAtual > 0 ? this.state.tempoAtual : "Ilimitado"}</div>
                                </div>}
                            </div>
                            {!this.state.iniciado && <span>&nbsp;</span>}

                        </div>
                        <div className="edb-col s6 edb-right-align edb-padding-small-right edb-padding-small-top">
                            <div className="edb-small edb-text-bold">{this.props.userContainer.state.profile.txScreenName}</div>
                            <div className="edb-tiny">{this.props.userContainer.state.profile.infoShow}</div>
                        </div>
                    </div>

                    <div className="edb-cell-row edb-margin-small-top">

                        <div className="edb-container edb-cell edb-cell-middle">
                            <span className=" edb-text-bold edb-margin-small-right">{this.state.numPeriodo}º PERÍODO</span>
                            <div className="edb-small2 edb-inline edb-line-height-medium">| {this.state.nomeSimulado}</div>
                        </div>
                        <div className="edb-cell edb-cell-middle">
                            <SimplePopover noPadding={true} rightAlign={true} content={<div className="edb-bar-block" style={{ right: 0 }}>
                                {/* <button className="edb-bar-item edb-button edb-medium ">Finalizar simulado</button> */}
                                <button className="edb-bar-item edb-button edb-medium ">Reportar erro</button>
                            </div>}>

                                <i className="fas fa-ellipsis-h edb-margin-small-right"></i>
                            </SimplePopover>
                        </div>
                    </div>

                    {/* <div className="edb-padding-small edb-margin-small-top edb-margin-small-left">
                        <span className=" edb-text-bold edb-margin-small-right">1º PERÍODO</span>
                        <div className="edb-small2 edb-inline edb-line-height-medium">| Simulado de desenvolvimento</div>
                    </div> */}
                </div>

                {/* *********** Instruções ************* */}
                {!this.state.iniciado && <div className="edb-row edb-padding-small-medium edb-padding-small-mobile">
                    <div className="edb-col s12 l8">
                        <div className="adap-white edb-round-large edb-padding ">

                            <Instrucoes semConsulta={this.state.semConsulta} tempoTotalMinutos={this.state.tempoTotalMinutos} totalQuestoes={this.getTotalQuestoes()} />

                            {/* ************ Escolha do Idioma **************** */}
                            {this.state.escolherIdioma && <div className="edb-center">
                                <div className="edb-margin-top edb-panel adap-light-yellow edb-padding edb-round edb-inline edb-left-align" >
                                    <b>Escolha seu idioma de preferência:</b>
                                    <div className="edb-small adap-text-red">ATENÇÂO: Após iniciar o simulado você não poderá alterar o idioma novamente.</div>
                                    <label className="edb-margin-small-top">
                                        <input type="radio" name="simuIdiomaSelecionado"
                                            value={IDIOMA_ID.INGLES}
                                            checked={this.state.idiomaSelecionado === IDIOMA_ID.INGLES}
                                            onChange={r => this.onClickSelecionarIdioma(r.currentTarget.value)}
                                        />
                                        <span className="edb-margin-small-left">Inglês</span>
                                    </label>
                                    <label className="edb-margin-small-top">
                                        <input type="radio" name="simuIdiomaSelecionado"
                                            value={IDIOMA_ID.ESPANHOL}
                                            checked={this.state.idiomaSelecionado === IDIOMA_ID.ESPANHOL}
                                            onChange={r => this.onClickSelecionarIdioma(r.currentTarget.value)}
                                        />
                                        <span className="edb-margin-small-left">Espanhol</span>
                                    </label>
                                </div>
                            </div>}

                            {/* ************ Botões de FECHAR e INICIAR simulado **************** */}
                            <div className="edb-row edb-margin-large-top ">
                                <div className="edb-col s6 edb-padding-small-right">
                                    <a href="#/" className="edb-button edb-round adap-red edb-block-mobile">
                                        <span className="edb-hide-medium edb-hide-large">Fazer depois</span>
                                        <span className="edb-hide-small">Fechar e fazer este simulado depois</span>
                                    </a>
                                </div>
                                <div className="edb-col s6 edb-right-align ">

                                    <EdbButton className="adap-green edb-block-mobile" content="Iniciar simulado"
                                        loadingContent="Iniciando..."
                                        loading={this.state.loadingIniciarSimulado}
                                        onClick={this.onClickIniciarSimulado} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>}

            {/* *********** Questões ************* */}
            {this.state.iniciado && <div>
                <div className="edb-row  edb-padding-small-medium edb-padding-small-mobile">
                    <div className="edb-col m8">
                        <Navegacao
                            questaoAtual={this.state.questaoAtual + 1}
                            totalQuestoes={this.getTotalQuestoes()}
                            temQuestaoDuvida={this.verificaTemQuestaoDuvida()}
                            temQuestaoEmBranco={this.verificaTemQuestaoEmBranco()}
                            onClickProxima={this.onClickProximaQuestao}
                            onClickAnterior={this.onClickQuestaoAnterior}
                            onClickProximaDuvida={this.onClickProximaDuvida}
                            onClickProximaEmBranco={this.onClickProximaEmBranco}
                        />

                        <Questao className="edb-margin-top edb-margin-bottom"
                            questao={this.getQuestaoAtual()}
                            numeroQuestao={this.state.questaoAtual + 1}
                            opcaoSelecionada={this.getQuestaoAtual().resposta}
                            loading={this.state.loadingQuestao}
                            onClickConfirmar={this.onClickConfirmar}
                            onClickDuvida={this.onClickDuvida}
                            onChangeOpcao={this.onChangeOpcao}
                        />

                        <Navegacao
                            questaoAtual={this.state.questaoAtual + 1}
                            totalQuestoes={this.getTotalQuestoes()}
                            temQuestaoDuvida={this.verificaTemQuestaoDuvida()}
                            temQuestaoEmBranco={this.verificaTemQuestaoEmBranco()}
                            onClickProxima={this.onClickProximaQuestao}
                            onClickAnterior={this.onClickQuestaoAnterior}
                            onClickProximaDuvida={this.onClickProximaDuvida}
                            onClickProximaEmBranco={this.onClickProximaEmBranco}
                        />

                        {this.state.iniciado && <div className="edb-col edb-right-align edb-hide-small edb-margin-top" >
                            <button className="edb-button edb-round adap-green" onClick={this.onClickFinalizar}>Finalizar simulado</button>
                        </div>}
                    </div>

                    <div className="edb-col m4 edb-padding-left ">
                        <div className="edb-hide-small edb-padding-large-right">
                            {/***************  Cartão Resposta (Dektop) ****************/}
                            <CartaoResposta
                                questaoAtual={this.state.questaoAtual + 1}
                                statusQuestoes={this.getStatusQuestoes()}
                                onClickQuestao={this.onClickQuestao} />
                        </div>
                        <div className="edb-hide-large edb-hide-medium">

                            {/*************** Botão flutuante Cartão Resposta ****************/}
                            <div className="edb-round-large adap-green edb-tiny edb-line-height-tiny edb-padding-small adap-cartap-resposta-btn-label"
                                onClick={this.abrirMenuCartaoResposta}>CARTÃO DE <br />RESPOSTA</div>

                            <div className="adap-badge-large adap-green adap-cartap-resposta-btn" onClick={this.abrirMenuCartaoResposta}>
                                <i className="fas fa-clipboard-list"></i>
                            </div>

                            {/*************** Menu flutuante Cartão Resposta ****************/}
                            <div className="edb-sidebar  edb-collapse" style={{ width: "300px", right: "0", top: "64px", display: (this.state.menuCartaoResposta ? 'block' : 'none') }}>
                                <button className="edb-button edb-display-topright edb-large"
                                    onClick={this.fecharMenuCartaoResposta}>&times;</button>

                                <CartaoResposta
                                    questaoAtual={this.state.questaoAtual + 1}
                                    statusQuestoes={this.getStatusQuestoes()}
                                    onClickQuestao={this.onClickQuestao} />
                            </div>

                        </div>
                    </div>
                </div>

                <div className="edb-hide-medium edb-hide-large edb-margin-top edb-margin-bottom edb-container">
                    <button className="edb-button edb-round adap-green edb-block" onClick={this.onClickFinalizar}>Finalizar simulado</button>
                </div>
            </div>}
            <div id="image-zoom"></div>
        </div>);
    }
}

//export default QuestoesPage;
//higher order component
export default (props) => (<Subscribe to={[UserContainer]}>
    {user => <QuestoesPage userContainer={user} {...props} />}
</Subscribe>);
